import { Loader2 } from 'lucide-react';

export default function PaymentElementSkeleton() {
  return (
    <div className='min-h-[200px] animate-pulse space-y-4'>
      {/* Payment method tabs skeleton */}
      <div className='flex space-x-2'>
        <div className='h-10 w-24 rounded-lg bg-muted'></div>
        <div className='h-10 w-24 rounded-lg bg-muted'></div>
      </div>

      {/* Card input skeleton */}
      <div className='space-y-3'>
        <div className='h-4 w-16 rounded bg-muted'></div>
        <div className='h-12 rounded-lg bg-muted'></div>
      </div>

      {/* Expiry and CVC skeleton */}
      <div className='grid grid-cols-2 gap-4'>
        <div className='space-y-2'>
          <div className='h-4 w-12 rounded bg-muted'></div>
          <div className='h-12 rounded-lg bg-muted'></div>
        </div>
        <div className='space-y-2'>
          <div className='h-4 w-8 rounded bg-muted'></div>
          <div className='h-12 rounded-lg bg-muted'></div>
        </div>
      </div>

      {/* Loading indicator */}
      <div className='flex items-center justify-center py-4'>
        <div className='flex items-center space-x-2 text-muted-foreground'>
          <Loader2 className='h-4 w-4 animate-spin' />
          <span className='text-sm'>Loading payment form...</span>
        </div>
      </div>
    </div>
  );
}
